import { render } from "./ReadArticleView.vue?vue&type=template&id=27697aba&scoped=true"
import script from "./ReadArticleView.vue?vue&type=script&lang=js"
export * from "./ReadArticleView.vue?vue&type=script&lang=js"

import "./ReadArticleView.vue?vue&type=style&index=0&id=27697aba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27697aba"]])

export default __exports__